<template>
    <AppSidebarComponent :title="$t('sidebar.navigation')">
        <AppNavItemGroup to="MainInformation">
            {{ $t('sidebar.items.mainInformation') }}
        </AppNavItemGroup>
        <AppNavItemGroup>
            {{ $t('sidebar.items.catalog') }}
            <template #children>
                <AppNavItemGroup to="IntegrationProductsTable">
                    {{ $t('sidebar.items.integrationProducts') }}
                </AppNavItemGroup>
                <AppNavItemGroup to="CategoriesCard">
                    {{ $t('sidebar.items.categories') }}
                </AppNavItemGroup>
                <AppNavItemGroup v-if="!isSupplier" to="TagsCard">
                    {{ $t('sidebar.items.tags') }}
                </AppNavItemGroup>
                <AppNavItemGroup v-if="!isSupplier" to="AiProcessesListPage">
                    {{ $t('sidebar.items.aiProcesses') }}
                </AppNavItemGroup>
                <AppNavItemGroup v-if="!isSupplier" to="ProductsSettings">
                    {{ $t('sidebar.items.settings') }}
                </AppNavItemGroup>
                <AppNavItemGroup v-if="!isSupplier" to="ProductsImports">
                    {{ $t('sidebar.items.productsImports') }}
                </AppNavItemGroup>
                <AppNavItemGroup v-if="!isSupplier" to="IntegrationProductCopyExportLink">
                    {{ $t('sidebar.items.copyExportLink') }}
                </AppNavItemGroup>
            </template>
        </AppNavItemGroup>
        <AppNavItemGroup v-if="!isSupplier">
            {{ $t('sidebar.items.sales') }}
            <template #children>
                <AppNavItemGroup to="IntegrationOrdersTable">
                    {{ $t('sidebar.items.orders') }}
                </AppNavItemGroup>
                <AppNavItemGroup to="OrdersSettings">
                    {{ $t('sidebar.items.settings') }}
                    <template #children>
                        <AppNavItemGroup to="IntegrationCustomFieldsSettings">
                            {{ $t('sidebar.items.customFields') }}
                        </AppNavItemGroup>
                        <AppNavItemGroup to="IntegrationStatusMatrix">
                            {{ $t('labels.status_matrix') }}
                        </AppNavItemGroup>
                    </template>
                </AppNavItemGroup>
            </template>
        </AppNavItemGroup>
    </AppSidebarComponent>
</template>
<script>
import AppSidebarComponent from '../../components/sidebar/AppSidebarComponent.vue';
import AppNavItem from '../../components/navbar/AppNavItem.vue';
import AppNavItemLink from '../../components/sidebar/AppNavItemLink.vue';
import AppNavItemGroup from '../../components/sidebar/AppNavItemGroup.vue';
import { IntegrationServiceEnum } from '../../enums/IntegrationServiceEnum';
import { mapGetters } from 'vuex';

export default {
    name: "IntegrationSidebarComponent",
    components: {
        AppSidebarComponent, AppNavItem, AppNavItemLink, AppNavItemGroup,
    },
    computed: {
        ...mapGetters('route', ['integration']),
        isSupplier() {
            return this.integration?.service === IntegrationServiceEnum.SUPPLIER
        }
    }
}
</script>
